import React from 'react';
import PropTypes from 'prop-types';

/**
 * secondary loading text for `Spinner`
 */
export default function SpinnerDescription({ children }) {
	return (
		<>
			<br />
			{typeof children === 'string' ? <p>{children}</p> : children}
		</>
	);
}

SpinnerDescription.propTypes = {
	children: PropTypes.any.isRequired
};
